import { NavLink } from "react-router-dom";
import Logo from "@/components/Logo";
import Icon from "@/components/Icon";
import { PRIMARY_NAV, MODULE_NAV, FOOTER_NAV } from "@/app/nav";

function NavItem({ item, onNavigate }) {
  return (
    <NavLink
      to={item.to}
      end={item.end}
      onClick={onNavigate}
      data-testid={`sidebar-${item.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
      className={({ isActive }) =>
        `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${
          isActive
            ? "bg-muted text-foreground"
            : "text-muted-foreground hover:bg-muted/60 hover:text-foreground"
        }`
      }
    >
      <Icon name={item.icon} className="h-[18px] w-[18px]" />
      {item.label}
    </NavLink>
  );
}

export function SidebarContent({ onNavigate }) {
  return (
    <div className="flex h-full flex-col">
      <div className="flex h-16 items-center px-5">
        <Logo imgClass="h-7" />
      </div>

      <div className="flex-1 overflow-y-auto px-3 py-2">
        <nav className="flex flex-col gap-1">
          {PRIMARY_NAV.map((item) => (
            <NavItem key={item.to} item={item} onNavigate={onNavigate} />
          ))}
        </nav>

        <p className="px-3 pb-2 pt-6 text-[10px] font-semibold uppercase tracking-[0.18em] text-muted-foreground/70">
          Modules
        </p>
        <div className="flex flex-col gap-1">
          {MODULE_NAV.map((m) => (
            <div
              key={m.label}
              className="flex cursor-not-allowed items-center justify-between rounded-xl px-3 py-2.5 text-sm font-medium text-muted-foreground/60"
              title="Coming in a future phase"
            >
              <span className="flex items-center gap-3">
                <Icon name={m.icon} className="h-[18px] w-[18px]" />
                {m.label}
              </span>
              <span className="rounded-full bg-muted px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide ring-1 ring-border">
                Soon
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-border px-3 py-3">
        <nav className="flex flex-col gap-1">
          {FOOTER_NAV.map((item) => (
            <NavItem key={item.to} item={item} onNavigate={onNavigate} />
          ))}
        </nav>
      </div>
    </div>
  );
}

export default function Sidebar() {
  return (
    <aside className="hidden w-64 shrink-0 border-r border-border bg-card lg:flex lg:flex-col" data-testid="app-sidebar">
      <SidebarContent />
    </aside>
  );
}
